import { z } from 'zod';
/**
 * Zod schema for RegisterRequest.
 * Ensures email is a valid email and password has a minimum length.
 */
export const RegisterRequestSchema = z.object({
    email: z.string().email({ message: 'Invalid email format' }),
    password: z.string().min(8, { message: 'Password must be at least 8 characters long' }),
});
/**
 * Zod schema for LoginRequest.
 */
export const LoginRequestSchema = z.object({
    email: z.string().email(),
    password: z.string(),
});
/**
 * Zod schema for ForgotPasswordRequest.
 */
export const ForgotPasswordRequestSchema = z.object({
    email: z.string().email(),
});
/**
 * Zod schema for ResetPasswordRequest.
 */
export const ResetPasswordRequestSchema = z.object({
    newPassword: z.string().min(8, { message: 'New password must be at least 8 characters long' }),
});
/**
 * Zod schema for ChangePasswordRequest.
 */
export const ChangePasswordRequestSchema = z.object({
    currentPassword: z.string(),
    newPassword: z.string().min(8, { message: 'New password must be at least 8 characters long' }),
});
/**
 * Zod schema for ResendVerificationRequest.
 */
export const ResendVerificationRequestSchema = z.object({
    email: z.string().email(),
});
/**
 * Zod schema for VerifyEmailRequest.
 */
export const VerifyEmailRequestSchema = z.object({
    verificationToken: z.string(),
});
//# sourceMappingURL=auth.schemas.js.map